import { useState, useEffect } from "react";
import * as S from "./styles";
import { ModalSync } from "@/components";
import { useClientHierarchy } from "@/hooks";
import { useDownloadFiles } from "@/talons";
import { RiLogoutBoxLine, RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";

const RcaLoggedBar = () => {
    const { selectedRCA, handleLogoutRCA } = useClientHierarchy();
    const { isOpenedModal, openModalSync, loading } = useDownloadFiles();
    const [isExpanded, setIsExpanded] = useState(true);
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    // Inicia o logout após um pequeno tempo para exibir o conteúdo original
    useEffect(() => {
        if (isLoggingOut) {
            const logout = async () => {
                await new Promise((resolve) => setTimeout(resolve, 1000)); // Aguarda 1s antes de iniciar o logout
                await handleLogoutRCA(); // Aguarda o logout finalizar
                openModalSync(false); // Fecha o modal
                setIsLoggingOut(false);
            };
            logout();
        }
    }, [isLoggingOut]);

    const handleOpenModal = () => {
        openModalSync(true); // Abre o modal
        setTimeout(() => setIsLoggingOut(true), 1000); // Aguarda 1s antes de iniciar o logout
    };

    return (
        <>
            <S.Container>
                <S.UserInfo>
                    <S.Message>Você está logado como</S.Message>
                    <S.UserName>{selectedRCA?.firstname}</S.UserName>
                </S.UserInfo>
                <S.LogoutButton onClick={handleOpenModal}>
                    <RiLogoutBoxLine />
                    <S.LogoutText>Sair</S.LogoutText>
                </S.LogoutButton>
                {/* <S.ToggleButton onClick={() => setIsExpanded(!isExpanded)}>
                    {isExpanded ? <RiArrowDownSLine /> : <RiArrowUpSLine />}
                </S.ToggleButton> */}
            </S.Container>

            {isOpenedModal && (
                <ModalSync isLoading={isLoggingOut || loading}>
                   
                </ModalSync>
            )}
        </>
    );
};

export default RcaLoggedBar;
